import ReactDOM from 'react-dom';
import Alert from '@mui/material/Alert';
import { COMPONENTE_ALERT, ROOT_ALERT_COMPONENT, TYPES_ALERTS } from '../Constants/Const';
import { Snackbar } from '@mui/material';

export const TransitionAlerts = ({open=false, message="Default Text", typeAlert=TYPES_ALERTS.success}) =>{

      let componetRoot = document.getElementById(ROOT_ALERT_COMPONENT);
      
      if(document.getElementById(COMPONENTE_ALERT)){
            document.getElementById(COMPONENTE_ALERT).remove();
      }

      let newAlert = document.createElement("div");

      newAlert.id = COMPONENTE_ALERT;
      
      ReactDOM.render(
                  <CreateAlert open={open}
                        handleCloseAlert={()=>newAlert.remove()}
                        typeAlert={typeAlert}
                        message={message}
            />, newAlert)

      componetRoot.appendChild(newAlert)


}

function CreateAlert({open=false, handleCloseAlert, message,typeAlert}){
      return (<Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={5000}
            open={open}
            onClose={handleCloseAlert}>
                  <Alert onClose={handleCloseAlert} severity={typeAlert} sx={{ width: '100%' }}>
                  {message}
                  </Alert>
            </Snackbar>);
}